import * as types from '../constants/ActionTypes'

export default function assessments(state = {}, action) {
	switch (action.type) {

		case types.SET_ASSESSMENTS:
			return action.payload.reduce((obj, assessment) => {
				obj[assessment._id] = assessment;
				return obj
			}, {});

		case types.INSERT_ASSESSMENT:
			return {...state, [action.payload._id]: action.payload};

		case types.SET_ASSESSMENT:
			return {...state, [action.payload._id]: action.payload};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/assessments.js